/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineTopFilters_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterMetal_viewer" | "SbSharedRefineMenuFilterStone_viewer" | "SbSharedRefineMenuFilterOrigin_viewer" | "SbSharedRefineMenuFilterCreator_viewer" | "SbSharedRefineMenuFilterMaterial_viewer" | "SbRespRefineMenuFilterDeliveryOptions_viewer">;
    readonly " $refType": "SbRespRefineTopFilters_viewer";
};
export type SbRespRefineTopFilters_viewer$data = SbRespRefineTopFilters_viewer;
export type SbRespRefineTopFilters_viewer$key = {
    readonly " $data"?: SbRespRefineTopFilters_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineTopFilters_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineTopFilters_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMetal_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterStone_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterOrigin_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterCreator_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMaterial_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDeliveryOptions_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'b854a7a17e5e5200f417d04c694507aa';
export default node;
